export const DefaultStateAnimateConfig = {
    duration: 200,
    easing: "cubicOut"
};
//# sourceMappingURL=config.js.map